import { AuthenticationServiceInterface } from 'domain/services';
import {
  AuthenticationChangePasswordUseCaseInterface,
  AuthenticationPasswordResetVerifyCodeUseCaseInterface,
  AuthenticationSendPasswordResetCodeUseCaseInterface,
  AuthSignOut,
  GetActiveSession,
  SignInViaImpersonateUseCaseInterface,
} from 'domain/usecases';

export class AuthenticationService implements AuthenticationServiceInterface {
  constructor(
    private readonly _authSignOut: AuthSignOut,
    private readonly _getActiveSession: GetActiveSession,
    private readonly _signInViaImpersonate: SignInViaImpersonateUseCaseInterface,
    private readonly _authenticationChangePassword: AuthenticationChangePasswordUseCaseInterface,
    private readonly _authenticationSendPasswordResetCode: AuthenticationSendPasswordResetCodeUseCaseInterface,
    private readonly _authenticationPasswordResetVerifyCode: AuthenticationPasswordResetVerifyCodeUseCaseInterface,
  ) {}

  async authSignOut(params: AuthSignOut.Params): Promise<AuthSignOut.Result> {
    return await this._authSignOut.execute(params);
  }

  async getActiveSession(
    params: GetActiveSession.Params,
  ): Promise<GetActiveSession.Result> {
    return await this._getActiveSession.execute(params);
  }

  async signInViaImpersonate(
    params: SignInViaImpersonateUseCaseInterface.Params,
  ): Promise<SignInViaImpersonateUseCaseInterface.Result> {
    return await this._signInViaImpersonate.execute(params);
  }

  // reset password
  authenticationSendPasswordResetCode(
    params: AuthenticationSendPasswordResetCodeUseCaseInterface.Params,
  ): Promise<AuthenticationSendPasswordResetCodeUseCaseInterface.Result> {
    return this._authenticationSendPasswordResetCode.execute(params);
  }

  // verify code
  authenticationPasswordResetVerifyCode(
    params: AuthenticationPasswordResetVerifyCodeUseCaseInterface.Params,
  ): Promise<AuthenticationPasswordResetVerifyCodeUseCaseInterface.Result> {
    return this._authenticationPasswordResetVerifyCode.execute(params);
  }

  // change password
  authenticationChangePassword(
    params: AuthenticationChangePasswordUseCaseInterface.Params,
  ): Promise<AuthenticationChangePasswordUseCaseInterface.Result> {
    return this._authenticationChangePassword.execute(params);
  }
}
